import React, { useEffect, useRef, useState, FC } from "react";
import { Button, message } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { getFormValidatorErrText } from "@/utils/utils"
import { globalPrompt } from "@/components/message";
import { useStockCheckDetailModel } from "./stockCheckDetailsModel";
import { DetailType } from "@/types/ScmEnums";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export const FormBox: FC<RouterParamType> = ({ id, mode, purchasePoDetails }) => {
    const { detailEditForm, detailAddForm, detailLookForm, updateAddFormVal, updatEditFormVal, getDetailEditOne, resetAddCatch, resetEditCatch } = useStockCheckDetailModel();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const { selectedNavId, addNav, replaceNav, getSelectedNavState, findNav } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode == DetailType.edit) {
            getDetailEditOne(id, mode)
        }
        mode == DetailType.look && getDetailEditOne(id, mode)

    }, [id, mode])
    useEffect(() => {
        return () => {
            !findNav("4-2-1") && resetAddCatch(mode);
            !findNav("4-2-2") && resetEditCatch(mode);
        }
    }, [selectedNavId])
    const baseFormItem: IYhFormItemsBox = {
        // title: "基础信息",
        title: Locale["Basic Info"],
        style: { padding: "18px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "制单员",
                fieldLabel: Locale["Creator"],
                disable: true,
                fieldName: "createUser",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "制单时间",
                fieldLabel: Locale["Creation Time"],
                disable: true,
                fieldName: "createTime",
            }, {
                type: FormItemTypeEnum.Datepicker,
                // fieldLabel: "开始时间",
                fieldLabel: Locale["Start Time"],
                showTime: true,
                fieldName: "startTime",
            }, {
                type: FormItemTypeEnum.Datepicker,
                // fieldLabel: "结束时间",
                fieldLabel: Locale["End Time"],
                showTime: true,
                fieldName: "endTime",
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "盘点结果",
                fieldLabel: Locale["Result"],
                fieldName: "result",
                disable: true,
                options: [{ label: Locale["Surplus"], value: "盘盈" }, { label: Locale["Loss"], value: "盘亏" }, { label: Locale["Equal"], value: "相符" }],
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "盘点类型",
                fieldLabel: Locale["Stocktaking  Type"],
                fieldName: "type",
                // options: [{ label: "1", value: "1" }],
                options: [{ label: Locale["initialization Doc"], value: "0" }, { label: Locale["Stocktaking Doc"], value: "1" }],
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note",
            }
        ]
    };

    const onChange = (changedValues: { [key: string]: any }) => {
        if (mode == DetailType.add) {
            updateAddFormVal(changedValues)
        } else if (mode == DetailType.edit) {
            updatEditFormVal(changedValues)
        }
    }
    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    const poFromConfig: IYhFormBox = {
        formRef: purchasePoDetails,
        labelCol: { span: 6 },
        labelAlign: "right",
        disabled: mode == DetailType.look,
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}